module.exports = {"150422100":"林东镇","150422101":"隆昌镇","150422102":"十三敖包镇","150422103":"碧流台镇","150422104":"富河镇","150422105":"白音勿拉镇","150422106":"哈拉哈达镇","150422200":"查干哈达苏木","150422201":"乌兰达坝苏木","150422202":"三山乡","150422203":"花加拉嘎乡","150422400":"上京高新技术产业集中区","150422401":"南塔工业集中区","150422402":"凤凰山工业集中区","150422403":"林东西城街道","150422404":"林东东城街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150422.json
// module id = 419
// module chunks = 0